
export const defaultLocation = 'nieuwe-meer'
export const defaultPreset = 'day'

//export const chartHeight = window.innerHeight / 5 - 60
export const chartPadding = 40
export const chartHeight = 105
